const common = {
  // Navigation
  nav_home: 'Home',
  nav_about_turkey: 'About Turkey',
  nav_turkey_culture: 'Culture in Turkey',
  nav_health_institutions: 'Health Institutions',
  nav_agencies: 'Health Tourism Agencies',
  nav_contact: 'Contact',

  nav_login: 'Login',
  nav_register: 'Sign Up',
  nav_user_login: 'User Login',
  nav_user_login_desc: 'Access member panel',
  nav_institution_login: 'Institution Login',
  nav_institution_login_desc: 'Access institution panel',
  nav_admin_login: 'Admin Login',
  nav_admin_login_desc: 'Platform management',
  nav_my_panel: 'My Panel',
  nav_institution_panel: 'Institution Panel',
  nav_admin_panel: 'Admin Panel',
  nav_user_panel: 'User Panel',
  nav_institution_label: 'Institution',
  nav_admin_label: 'Admin',
  nav_user_label: 'User',
  nav_logout: 'Logout',
  nav_warning_title: 'IMPORTANT NOTICE',
  nav_warning_text: 'Health Travel Türkiye Platform is a digital platform that brings together people in need of health services with health facilities and health tourism agencies offering international health services. Health tourism services are provided on this platform. Health institutions are certified and authorized by the relevant country\'s competent authorities. This platform is for informational purposes only and does not contain any medical diagnosis, treatment recommendations or health guidance. The platform operator has no commercial or medical liability. Please consult a specialist physician for your health problems.',

  // Footer
  footer_description: 'Access approved health institutions authorized by Turkey\'s Ministry of Health. Get healthy safely and quickly.',
  footer_quick_links: 'Quick Links',
  footer_for_institutions: 'For Institutions',
  footer_institution_login: 'Institution Login',
  footer_register: 'Sign Up',
  footer_contact: 'Contact',
  footer_email_label: 'Email',
  footer_address_label: 'Address',
  footer_address_value: 'Istanbul, Turkey',
  footer_rights: 'All rights reserved.',
  footer_privacy: 'Privacy Policy',
  footer_kvkk: 'KVKK Disclosure Text',
  footer_terms: 'Terms of Use',
  footer_powered: 'Powered by Readdy',
  footer_newsletter_title: 'Stay Updated',
  footer_newsletter_desc: 'Subscribe to get the latest news about health tourism in Turkey.',
  footer_newsletter_placeholder: 'Your email address',
  footer_newsletter_btn: 'Subscribe',
  footer_newsletter_sending: 'Sending...',
  footer_newsletter_success: 'Thank you! You have been subscribed.',
  footer_newsletter_error: 'An error occurred. Please try again.',

  // Common UI
  loading: 'Loading...',
  search: 'Search',
  filter: 'Filters',
  clear: 'Clear',
  clear_all: 'Clear All',
  all: 'All',
  view_all: 'View All',
  view_details: 'View Details',
  explore: 'Explore',
  back: 'Back',
  save: 'Save',
  cancel: 'Cancel',
  submit: 'Submit',
  send: 'Send',
  sending: 'Sending...',
  success: 'Success',
  error: 'Error',
  no_results: 'No Results Found',
  approved: 'Approved',
  pro_member: 'PRO',
  doctor_count: '{{count}} Doctor',
  verified: 'Verified',
  accreditation: 'Accreditation',
  official_accreditation: 'Official Accreditation & Assurance',
  health_turkey: 'Health Türkiye',
  health_turkey_desc: 'Health Tourism Platform',
  ministry_health: 'Republic of Turkey Ministry of Health',
  ministry_health_desc: 'Approved Health Institution',
  ministry_culture: 'Republic of Turkey Ministry of Culture and Tourism',
  ministry_culture_desc: 'Health Tourism Authorization Certificate',

  // Auth
  user_type: 'User',
  institution_type: 'Institution',
  admin_type: 'Admin',

  // Breadcrumb names (Schema.org JSON-LD)
  breadcrumb_home: 'Home',
  breadcrumb_contact: 'Contact',
  breadcrumb_institutions: 'Health Institutions',
  breadcrumb_agencies: 'Health Tourism Agencies',
  breadcrumb_about_turkey: 'About Turkey',
  breadcrumb_turkey_culture: 'Turkey Culture',

  breadcrumb_kvkk: 'KVKK',
  breadcrumb_privacy: 'Privacy Policy',
  breadcrumb_terms: 'Terms of Use',


  // SEO meta — page titles & descriptions
  seo_home_title: 'Health Travel Türkiye - Turkey Health Tourism Platform',
  seo_home_desc: 'Discover Turkey\'s accredited health institutions for patients coming from abroad. Hair transplant, dental treatment, aesthetic surgery, IVF and more.',
  seo_turkiye_title: 'About Turkey - Travel Guide | Health Travel Türkiye',
  seo_turkiye_desc: 'Health Travel Türkiye travel guide: Comprehensive guide about Turkey\'s cities, historical sites, natural wonders and practical travel information.',
  seo_kultur_title: 'Turkey Culture - Traditions, Cuisine & Life | Health Travel Türkiye',
  seo_kultur_desc: 'Discover Turkey\'s rich cultural heritage: traditions, cuisine, festivals, hammam culture, shopping and social life.',
  seo_contact_title: 'Contact - Health Travel Türkiye',
  seo_contact_desc: 'Contact Health Travel Türkiye. Reach us for questions about health tourism in Turkey.',

  seo_kvkk_title: 'KVKK Disclosure Text - Personal Data Protection | Health Travel Türkiye',
  seo_kvkk_desc: 'Health Travel Türkiye personal data protection and KVKK disclosure text.',
  seo_privacy_title: 'Privacy Policy - Personal Data Security | Health Travel Türkiye',
  seo_privacy_desc: 'Health Travel Türkiye privacy policy and personal data security principles.',
  seo_terms_title: 'Terms of Use - Platform Terms | Health Travel Türkiye',
  seo_terms_desc: 'Health Travel Türkiye platform terms of use and user agreement.',

  seo_institutions_title: 'Health Institutions in Turkey | Health Travel Türkiye',
  seo_institutions_desc: 'Compare approved health institutions across Turkey. Find the best clinics for hair transplant, dental, aesthetic surgery, IVF and more.',
  seo_agencies_title: 'Health Tourism Agencies | Health Travel Türkiye',
  seo_agencies_desc: 'Find health tourism agencies that organize your medical trip, accommodation and travel needs in Turkey.',
  seo_register_title: 'Sign Up - Join Health Travel Türkiye',
  seo_register_desc: 'Create your account on Health Travel Türkiye. Register as a patient or health institution to access all features.',

};

export default common;
